/**
 * Determinate bar (`value` 0–100) or indeterminate animated segment, with an optional label.
 * Uses the global `.progress-track` / `.progress-fill` styles (accent fill).
 */
export function ProgressBar({
  value,
  indeterminate,
  label,
}: {
  value?: number
  indeterminate?: boolean
  label?: string
}) {
  return (
    <div>
      {label && <div className="mb-1.5 font-mono text-[11px] text-text-3">{label}</div>}
      <div
        className="progress-track"
        role="progressbar"
        aria-label={label ?? 'Progress'}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={indeterminate ? undefined : Math.round(value ?? 0)}
      >
        {indeterminate ? (
          <div className="progress-fill progress-fill--indeterminate" />
        ) : (
          <div className="progress-fill" style={{ width: `${value ?? 0}%` }} />
        )}
      </div>
    </div>
  )
}
